import { useApi } from './index';

// Market Summary
export const useMarketSummary = () => {
  return useApi('/market/summary');
};

// Volume History
export const useVolumeHistory = (window = '24h', interval = 'hour') => {
  const result = useApi(`/market/volume/history?window=${window}&interval=${interval}`);
  
  
  return result;
};

// Market Spread
export const useMarketSpread = (window = '24h') => {
  return useApi(`/market/spread?window=${window}`);
};

// Listings Under Summary
export const useListingsUnderSummary = () => {
  return useApi('/listings/under/summary');
};
